import {all, fork, put, call, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import AuthActions from '../Auth/actions';
import {get, puto} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";

// Read user
export function* readUserRequest() {
    yield takeEvery(actions.READ_USER_REQUEST, function* (payload, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/user', null, context);
            const data = yield response.data;

            yield put({
                type: actions.READ_USER_SUCCESS,
                user: data.user,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_USER_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readUserSuccess() {
    yield takeEvery(actions.READ_USER_SUCCESS, () => {});
}
export function* readUserError() {
    yield takeEvery('READ_USER_ERROR', function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update user
export function* updateUserRequest() {
    yield takeEvery(actions.UPDATE_USER_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(puto, '/user', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.UPDATE_USER_SUCCESS,
                user: data.user,
            });
        }
        catch (error) {
            yield put({
                type: actions.UPDATE_USER_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateUserSuccess() {
    yield takeEvery(actions.UPDATE_USER_SUCCESS, function* () {
        yield message.success(t`User profile is updated.`);
    });
}
export function* updateUserError() {
    yield takeEvery(actions.UPDATE_USER_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update user password
export function* updateUserPasswordRequest() {
    yield takeEvery(actions.UPDATE_USER_PASSWORD_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(puto, '/user/password', request, context);

            // OK
            yield put({
                type: actions.UPDATE_USER_PASSWORD_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.UPDATE_USER_PASSWORD_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateUserPasswordSuccess() {
    yield takeEvery(actions.UPDATE_USER_PASSWORD_SUCCESS, function* () {
        yield message.success(t`User password is updated.`);
    });
}
export function* updateUserPasswordError() {
    yield takeEvery(actions.UPDATE_USER_PASSWORD_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update user locale
export function* updateUserLocaleRequest() {
    yield takeEvery(actions.UPDATE_USER_LOCALE_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(puto, '/user/locale', request, context);
            const data = yield response.data;

            // OK // Set local storage and app's locale store
            yield put({ type: AppActions.APP_CHANGE_LOCALE, locale: data.user.locale});
            // update Session's user's locale
            yield put({ type: AuthActions.CHANGE_SESSION_LOCALE, locale: data.user.locale});
            yield put({
                type: actions.UPDATE_USER_LOCALE_SUCCESS,
                user: data.user,
            });
        }
        catch (error) {
            yield put({
                type: actions.UPDATE_USER_LOCALE_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateUserLocaleSuccess() {
    yield takeEvery(actions.UPDATE_USER_LOCALE_SUCCESS, function* () {
    // yield message.success(t`Language updated.`);
    });
}
export function* updateUserLocaleError() {
    yield takeEvery(actions.UPDATE_USER_LOCALE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(readUserRequest),
        fork(readUserSuccess),
        fork(readUserError),
        fork(updateUserRequest),
        fork(updateUserSuccess),
        fork(updateUserError),
        fork(updateUserPasswordRequest),
        fork(updateUserPasswordSuccess),
        fork(updateUserPasswordError),
        fork(updateUserLocaleRequest),
        fork(updateUserLocaleSuccess),
        fork(updateUserLocaleError),
    ]);
}
